<form class="form">
  <span class="text-show-md">{{'labels.select-language' | translate}}</span>
  <mat-form-field appearance="fill"> 
    <input type = "text" 
           matInput
           aria-label="Locales"
           [matAutocomplete]="auto"
           [formControl]="languagesFormControl">
    <mat-icon class="aggregator-arrow-selector" matSuffix>
      <div class="mat-select-arrow-wrapper">
        <i class="icon icon-world"></i>
      </div>
    </mat-icon>
    <mat-autocomplete #auto="matAutocomplete">
        <mat-option 
          *ngFor="let language of languages" 
          [value]="language.name.toLowerCase()"
          (click)="onOptionClick(language)"
        >
          <span> {{ language.name}} </span>
        </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
